(function () {
  "use strict";

  var _lastKnownTotal = null;

  function formatMoneySafe(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        var fmt =
          (window.theme && (window.theme.moneyFormat || window.theme.money_format)) ||
          window.Shopify.money_format ||
          "{{amount}}";
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    return "£" + (cents / 100).toFixed(2);
  }

  function renderBars(cartTotal) {
    _lastKnownTotal = cartTotal;
    var bars = document.querySelectorAll("[data-free-gift-bar]");
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var thresholdCents = parseInt(bar.getAttribute("data-threshold-cents"), 10) || 7500;
      var messageEl = bar.querySelector(".free-gift-bar__message");
      var progressWrap = bar.querySelector(".free-gift-bar__bar");
      var progressEl = bar.querySelector(".free-gift-bar__bar-progress");

      var remainder = thresholdCents - cartTotal;
      var progress = Math.min(Math.max(thresholdCents > 0 ? (cartTotal / thresholdCents) * 100 : 0, 0), 100);

      bar.setAttribute("data-cart-total", cartTotal);

      if (remainder <= 0) {
        bar.classList.add("free-gift-bar--success");
        if (messageEl) messageEl.textContent = "Your order qualifies for a free gift!";
      } else {
        bar.classList.remove("free-gift-bar--success");
        if (messageEl) {
          messageEl.innerHTML =
            'Only <span class="fs-body-bold">' +
            formatMoneySafe(remainder) +
            "</span> away from your free gift!";
        }
      }

      if (progressWrap) progressWrap.style.setProperty("--progress-width", progress + "%");
      if (progressEl) {
        progressEl.style.width = progress + "%";
        progressEl.style.setProperty("--progress-width", progress + "%");
      }
    });
  }

  function fetchAndRender() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBars(cart.total_price); })
      .catch(function () {
        if (_lastKnownTotal !== null) renderBars(_lastKnownTotal);
      });
  }

  function initFreeGiftBar() {
    fetchAndRender();

    ["cart:updated", "cart:refresh", "ajaxProduct:added", "cart:add",
     "cart:added", "cart:change", "theme:cart:open"].forEach(function (evt) {
      document.addEventListener(evt, function () { fetchAndRender(); });
    });

    var quickCart = document.querySelector('[data-section-type="quick-cart"]');
    if (quickCart) {
      new MutationObserver(function () {
        fetchAndRender();
      }).observe(quickCart, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFreeGiftBar);
  } else {
    initFreeGiftBar();
  }
})();